import { Helper } from '@/mixin/helper'
export default [
  {
    path: '/login/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ '@/router/views/account/login'),
    meta: {
      guestPage: true,
      hasAccess: true,
      beforeResolve (_, routeFrom, next) {
        // If the user is already logged in
        if (localStorage.getItem('token') !== null) {
          // Redirect to the home page instead
          Helper.methods.userLogging('Login', _)
          window.location.href = '/'
        } else {
          if (localStorage.getItem('domainName') !== null) {
            // Prevent local development cannot go to login
            if (localStorage.getItem('domainName') === window.location.host) {
              return next()
            }

            const domainNameExpired = localStorage.getItem('domainNameExpired')
            if (domainNameExpired !== undefined && Date.now() >= domainNameExpired) {
              return next()
            }
            window.location.href = `${window.location.protocol}//${localStorage.getItem(
              'domainName'
            )}/login`
          } else {
            next()
          }
        }
      }
    }
  },
  {
    path: '/forgotpassword/',
    name: 'Forgot Password',
    component: () => import(/* webpackChunkName: "auth" */ '@/router/views/account/forgotpassword/email')
  },
  {
    path: '/forgotpassword/verification',
    name: 'OTP Verification',
    component: () => import(/* webpackChunkName: "auth" */ '@/router/views/account/forgotpassword/verification')
  },
  {
    path: '/forgotpassword/reset',
    name: 'Reset Password',
    component: () => import(/* webpackChunkName: "auth" */ '@/router/views/account/forgotpassword/resetpassword')
  },
  {
    path: '/forgotpassword/result',
    name: 'Password Changed',
    component: () => import(/* webpackChunkName: "auth" */ '@/router/views/account/forgotpassword/result')
  },
  {
    path: '/authenticate/:auth',
    name: 'auth',
    mixins: [Helper],
    meta: {
      guestPage: true,
      hasAccess: true,
      beforeResolve (_, routeFrom, next) {
        // If the user is already logged in
        if (localStorage.getItem('token') !== null) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Check Auth Token
          if (_.params.auth !== null) {
            localStorage.setItem('token', _.params.auth)
            localStorage.setItem('domainName', window.location.host)
            Helper.methods.userLogging('Login', _)

            window.location.href = '/?isLoginSuccess=true'
          } else {
            // Continue to the login page
            next({ name: 'Login' })
          }
        }
      }
    }
  },
  {
    path: '/logout/',
    name: 'logout',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve (_, routeFrom, next) {
        Helper.methods.userLogging('Logout', _)

        localStorage.removeItem('token')
        localStorage.removeItem('domainName')
        localStorage.removeItem('domainNameExpired')
        localStorage.removeItem('payload')
        localStorage.removeItem('fcm')

        next({ name: 'Login' })
      }
    }
  },
  {
    path: '/404/',
    name: '404',
    component: require(/* webpackChunkName: "other" */ '@/router/views/utility/404').default
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404'
  }
]
